import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function Portrait() {
  return (
    <Component>
      <Slider />
      <Content>
        <Title />
        <Subtitle />
        <Tags>
          <Tag />
          <Tag />
          <Tag />
          <Tag />
        </Tags>
        <Badges>
          <Badge />
          <Badge />
        </Badges>
        <Price />
        <Link />
        <Share />
      </Content>
    </Component>
  );
}

export default Portrait;

const Component = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.gray500};
`;

const Slider = styled.div`
  position: relative;
  padding-top: 65.481%;
  border-radius: 8px 8px 0 0;
  ${placeholderAnimationCss}

  ${media.tablet(css`
    padding-top: 53.355%;
  `)}
`;

const Content = styled.div`
  position: relative;
  padding: 25px 20px 20px;
  border-radius: 0 0 8px 8px;
  background: ${(props) => props.theme.white_1};

  ${media.laptop(css`
    padding: 27px 15px 17px;
  `)}

  ${media.tablet(css`
    padding: 15px 12px 12px;
  `)}
`;

const Title = styled.div`
  max-width: 60%;
  height: 29px;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptop(css`
    height: 23px;
  `)}

  ${media.tablet(css`
    height: 19px;
  `)}
`;

const Subtitle = styled.div`
  max-width: 20%;
  height: 19px;
  margin-top: 5px;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptop(css`
    height: 14px;
  `)}

  ${media.tablet(css`
    height: 12px;
  `)}
`;

const Tags = styled.div`
  display: flex;
  margin-top: 24px;

  ${media.tablet(css`
    margin-top: 15px;
  `)}
`;

const Tag = styled.div`
  flex: 0 0 18%;
  height: 36px;
  border-radius: 5px;
  margin-bottom: 5px;
  ${placeholderAnimationCss}

  &:not(:first-child) {
    margin-left: 5px;
  }

  ${media.laptop(css`
    height: 27px;
  `)}

  ${media.tablet(css`
    height: 21px;
  `)}
`;

const Badges = styled.div`
  display: flex;
  margin-top: 10px;
`;

const Badge = styled.div`
  flex: 0 0 25%;
  height: 32px;
  border-radius: 28px;
  margin-bottom: 5px;
  ${placeholderAnimationCss}

  &:not(:first-child) {
    margin-left: 5px;
  }

  ${media.laptop(css`
    height: 24px;
  `)}

  ${media.tablet(css`
    height: 20px;
  `)}
`;

const Price = styled.div`
  max-width: 50%;
  height: 45px;
  margin-top: 22px;
  border-radius: 2px;
  clip-path: polygon(
    0% 0%,
    calc(100% - 14px) 0%,
    100% 50%,
    calc(100% - 14px) 100%,
    0% 100%
  );
  ${placeholderAnimationCss};

  ${media.laptop(css`
    height: 30px;
    margin-top: 20px;
  `)}

  ${media.tablet(css`
    margin-top: 15px;
  `)}
`;

const Link = styled.div`
  max-width: 100px;
  height: 23px;
  margin: 23px auto 0;
  border-radius: 8px;
  ${placeholderAnimationCss};

  ${media.laptop(css`
    height: 17px;
    margin: 20px auto 0;
  `)}

  ${media.tablet(css`
    margin: 15px auto 0;
  `)}
`;

const Share = styled.div`
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  ${placeholderAnimationCss};

  ${media.laptop(css`
    left: 15px;
    bottom: 17px;
    width: 18px;
    height: 18px;
    border-radius: 4px;
  `)}

  ${media.tablet(css`
    left: 12px;
    bottom: 14px;
    width: 15px;
    height: 15px;
  `)}
`;
